import React from "react";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";

import ManageMyGivingPage from "Giving/ManageMyGivingPage";

import HomePage from "./HomePage";
import MemberPortalToolbar from "./MemberPortalToolbar";
import NotesPage from "./NotesPage";
import { memberPortalRoutes } from "./constants";

const Public = () => {
  return (
    <BrowserRouter>
      <Switch>
        <Route path={memberPortalRoutes.home} exact>
          <HomePage />
        </Route>

        <Route path={memberPortalRoutes.notes}>
          <NotesPage />
        </Route>

        <Route path={memberPortalRoutes.give}>
          <ManageMyGivingPage />
        </Route>

        {/* Catch-all redirect for invalid /home/* paths */}
        <Route path="/home/*">
          <Redirect to={memberPortalRoutes.home} />
        </Route>
      </Switch>

      <MemberPortalToolbar />
    </BrowserRouter>
  );
};

export default Public;
